import React from 'react'
import { containerIds } from 'modules/ui'
import { ROLE } from 'modules/companyEmployee'

export default class Employee extends React.Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  async onChange(e) {
    const { ui, actions, employee, updateCompanyEmployee } = this.props
    const input = e.target
    const request = {
      id: employee.id,
      role: parseInt(input.value, 10),
    }

    try {
      const res = await updateCompanyEmployee(
        {
          companyEmployee: request,
        },
        1,
        20,
      )
      const resData = res.data.updateCompanyEmployee
      if (resData && resData.userErrors && resData.userErrors.length > 0) {
        const errorMessage = resData.userErrors.map(m => m.message).join('\n')
        window.alert(errorMessage)
      }
      actions.setCompany(resData.company)
    } catch (error) {
      console.log(error)
      const errorMessage = `${i18n.t('error.500.title')}\n${error.message}`
      window.alert(errorMessage)
    } finally {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        mutateLoading: false,
      })
    }
  }

  async onClick(e) {
    e.preventDefault()
    const { actions, employee, deleteCompanyEmployee } = this.props
    try {
      if (window.confirm(i18n.t('page.employee.l_00001'))) {
        const res = await deleteCompanyEmployee(
          {
            companyEmployeeId: employee.id,
          },
          1,
          20,
        )
        const resData = res.data.deleteCompanyEmployee
        if (resData && resData.userErrors && resData.userErrors.length > 0) {
          const errorMessage = resData.userErrors.map(m => m.message).join('\n')
          window.alert(errorMessage)
        } else {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            successfulMsg: i18n.t('page.business.employee.l_00002'),
          })
        }

        actions.setCompany(resData.company)
        setTimeout(() => {
          actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
            successfulMsg: null,
          })
        }, 5000)
      }
    } catch (error) {
      console.log(error)
      const errorMessage = `${i18n.t('error.500.title')}\n${error.message}`
      window.alert(errorMessage)
    } finally {
      actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
        mutateLoading: false,
      })
    }
  }

  render() {
    const { ui, employee } = this.props

    return (
      <tr
        key={employee.id}
        className="business-reservation__line business-employee__line"
      >
        <td className="business-employee__name business-employee__list-name">
          <img
            src={employee.profileImage}
            alt={employee.name}
            className="business-employee__name-icon mr10"
          />
          <p className="pt7">{employee.name}</p>
        </td>
        <td className="business-employee__authority">
          <label className="business-reservation__search-select business-employee__authority-form">
            <select
              name="role"
              value={employee.role}
              className="business-reservation__search-form-status"
              onChange={this.onChange}
            >
              <option value={ROLE.ADMIN}>
                {i18n.t('page.employee.l_00003')}
              </option>
              <option value={ROLE.MEMBER}>
                {i18n.t('page.employee.l_00004')}
              </option>
            </select>
            <span className="baloon baloon-bottom user-detail-baloon mod-tooltip__detail business-employee__authority-tooltip">
              <span className="baloon-inner">
                {i18n.t('page.employee.l_00005')}
              </span>
            </span>
          </label>
        </td>
        <td className="business-employee__mail">
          <p className="pt7">{employee.email}</p>
        </td>
        <td className="business-employee__confirm">
          <a
            href="#"
            onClick={this.onClick}
            className="business-employee__release"
          >
            <i className="fa fa-times" />
          </a>
        </td>
      </tr>
    )
  }
}
